import React from 'react';

import './menuSlider.scss';
import { Link } from 'react-router-dom';
import Button from '../forms/buttons/Button';
import GraphQlClient from '../services/graphql';
import {useTranslation} from "react-i18next";
import {LinkLog} from "../services/interactions/elements/link";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";

const MenuLink_ = ({ current, href, title, description, notifyJsx }) => {
    return (
        <div className={`_link ${current ? 'current' : ''}`}>
            {
                current ?
                    <Link to={href}>
                        <h3>{title}</h3>
                        <p>{description}</p>
                    </Link>
                    :
                    <a href={href}>
                        <h3>{title}</h3>
                        <p>{description}</p>
                    </a>
            }
            {
                notifyJsx ? notifyJsx : ''
            }
        </div>
    )
}

const MenuLink = LinkLog(MenuLink_);

const MenuSlider = ({ currentUser, onLogout }) => {
    const {t} = useTranslation(['menu'])
    const logout = () => {
        AuditTrail.sendLog(PAGES.PAGE_VIEW, {tag: 'button', event: 'onClick', action: 'menu slider button logout'});
        onLogout()
        GraphQlClient.logout(true);
    }


    return (
        <div id="MenuSlider">
            <div className="_linkHolder">
                {
                    currentUser && currentUser.clinician && currentUser.clinician.role !== 'staff' ?
                    <MenuLink
                    title={t('command-center')}
                    description={t('command-description')}
                    href={process.env.REACT_APP_COMMAND_URI}
                    />
                    : ''
                }
                <MenuLink
                    title={t('admin')}
                    description={t('admin-description')}
                    href='/programs'
                    current={true}
                />
            </div>
            <div className="_logout">
                <p className="_whom">{t('logged-as')} {!!currentUser && !!currentUser.bio ? `${currentUser.bio.firstname || ''} ${currentUser.bio.lastname || ''}` : ''}</p>
                <Button className="tertiary" handleClick={logout}>
                    Logout
                </Button>
            </div>
            <div className="_branding">

                <div className="row">
                    <p>{t('admin')} {process.env.REACT_APP_VERSION ? process.env.REACT_APP_VERSION : 'BETA'}
                    </p>
                </div>
                <div className="row logo">
                    <p>
                        {t('cherish-name')} {new Date().getFullYear()}<br />
                        {t('rights')}
                    </p>
                    <img src="https://logoassets.s3.us-east-2.amazonaws.com/cherish-logo-trim_white.png" alt="cherish logo" />
                </div>
            </div>
        </div>
    )
}

export default MenuSlider;
